import { render } from "./UpWizardV310.vue?vue&type=template&id=41d52872&scoped=true"
import script from "./UpWizardV310.vue?vue&type=script&lang=js"
export * from "./UpWizardV310.vue?vue&type=script&lang=js"

import "./UpWizardV310.vue?vue&type=style&index=0&id=41d52872&scoped=true&lang=css"

import exportComponent from "C:\\Apps\\AppBase\\app-base-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41d52872"]])

export default __exports__